import axios from "axios";

const GetAllMonthlyAllocations = async () => {
    return axios.get(`MonthlyAllocation/GetMonthlyAllocation`).then((response) => response);
}

const GetMonthlyAllocationById = async (id) => {
    return axios.get(
        `MonthlyAllocation/GetMonthlyAllocationById`,
        {
            params: {
                p_allocationId: id,
            }
        }
    )
    .then((response) => response);
}

const GetMonthlyAllocationByYearAndMonth = async (year, month) => {
    return axios.get(
        `MonthlyAllocation/GetMonthlyAlloByYearAndMonth`,
        {
            params: {
                p_year: year,
                p_month: month,
            }
        }
    )
    .then((response) => response);
}

const AddMonthlyAllocation = async (payload) => {
    return axios.post(`MonthlyAllocation/AddMonthlyAllocation`, null, {
        params: {
            p_year: payload.year,
            p_month: payload.month,
            p_categoryCode: payload.categoryCode ?? "_",
            p_allocationDays: payload.allocationDays ?? 0,
            p_allocationHours: payload.allocationHours ?? 0,
        }
    })
    .then((response) => response);
}

const UpdateMonthlyAllocationStatus = async (payload) => {
    return axios.post(`MonthlyAllocation/UpdateStatusMonthlyAllocation`, null, {
        params: {
            p_allocationId: payload.allocationId,
            p_isActive: payload.isActive,
        }
    })
    .then((response) => response);
}

const UpdateMonthlyAllocation = async (payload) => {
    return axios.post(`MonthlyAllocation/UpdateMonthlyAllocation`, null, {
        params: {
            p_allocationId: payload.allocationId,
            p_year: payload.year,
            p_month: payload.month,
            p_categoryCode: payload.categoryCode ?? "_",
            p_allocationDays: payload.allocationDays ?? 0,
            p_allocationHours: payload.allocationHours ?? 0,
        }
    })
    .then((response) => response);
}

const MonthlyAllocationService = {
    GetAllMonthlyAllocations,
    GetMonthlyAllocationById,
    GetMonthlyAllocationByYearAndMonth,
    AddMonthlyAllocation,
    UpdateMonthlyAllocationStatus,
    UpdateMonthlyAllocation,
}

export default MonthlyAllocationService;